(function() {
    'use strict';

    angular.module('auth.signIn', [
        'focus-if',

        'shared.util',
    ]);
})();
